import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Separator } from '@change/ds-core-ui/Separator';

import { JoinTheCommunity } from './components/JoinTheCommunity';
import { useJoinTheCommunity } from './components/JoinTheCommunity/hooks/useJoinTheCommunity';
import { usePageFooter } from './hooks/usePageFooter';

export const PageFooter: React.FC<EmptyProps> = () => {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	const {
		data: { displayed: joinTheCommunityDisplayed },
	} = useJoinTheCommunity();

	return (
		<div className="flex flex-col gap-7 px-4 py-7 text-center md:mt-5">
			<JoinTheCommunity />

			{joinTheCommunityDisplayed && <Separator className="m-0" />}

			<Button
				as="a"
				href={skipUrl}
				onClick={handleSkipClick}
				data-qa="skip-link"
				variant="tertiary"
				size="large"
				className="self-center"
			>
				{skipLabel}
			</Button>
		</div>
	);
};
